import { computed } from "vue";

import useAuth from "@/composition/shared/useAuth.ts";

export function useMessengerAuthor() {
  const { user } = useAuth();

  const messengerAuthor = computed(() => ({
    creatorDpaId: user.value?.account_id ?? "",
    creatorFirstName: user.value?.given_name ?? "",
    creatorLastName: user.value?.family_name ?? "",
    creatorCompany: user.value?.company ?? "",
    creatorImage: user.value?.picture ?? "",
    creatorInitials: user.value?.initials ?? "",
    creatorEmail: user.value?.email ?? "",
    creatorPhone: user.value?.phone_number ?? "",
  }));

  return {
    messengerAuthor,
  };
}
